<main>
  <h3 data-cy="commands-txt">Left click to reveal cell content or right click to flag / unflag</h3>
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h3 {
    color: black;
    font-size: 1em;
    font-weight: 100;
  }
</style>
